import { useState } from "react";
import emailjs from "emailjs-com";
import React from "react";
import { Link } from 'react-router-dom';

const initialState = {
  name: "",
  email: "",
  message: "",
};

export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);
  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const clearState = () => setState({ ...initialState });

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .sendForm("service_u1z35xf", "template_dnj82xc", e.target, "WUfIrZrSQh-kQI2e0")
      .then(
        (result) => {
          console.log(result.text);
          setSuccessMessage("Your message has been sent!");
          clearState();
        },
        (error) => {
          console.log(error.text);
          setSuccessMessage("There was an error sending your message.");
        }
      );
  };

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Get In Touch</h2>
                <p>
                  Please fill out the form below to send us an email and we will
                  get back to you as soon as possible.
                </p>
              </div>
              <form name="sentMessage" validate="true" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Name"
                        required
                        value={name}
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        required
                        value={email}
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="Message"
                    required
                    value={message}
                    onChange={handleChange}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                <div id="success"></div>
                <button type="submit" className="btn btn-custom btn-lg">
                  Send Message
                </button>
              </form>
              {successMessage && (
                <div className="alert alert-success" style={{ marginTop: "20px" }}>
                  {successMessage}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">

          <Link to="/qrscan" style={{ textDecoration: "underline", color: "inherit" }}>
            Scan QR Code
          </Link>
          <span> | </span>
          <Link to="/savemywords" style={{ textDecoration: "underline", color: "inherit" }}>
            Secure Mnemonic
          </Link>
          <br />
          <p style={{ margin: "5px" }}>
            &copy; 2026 Dr. Crypto. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};
